// extracted by mini-css-extract-plugin
export default {"codeBut":"index_codeBut__sfdYn"};